export default __webpack_public_path__ + "static/media/sort-3.21380d3e.svg";